import { getAutocompleteEquality } from '@Utils/helpers/muiHelpers';
import {
    Autocomplete,
    AutocompleteChangeReason,
    TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import Select from '@Components/DomElements/Select';
import SelectOption from '@Components/DomElements/SelectOption';
import { IFileUploadHeader } from '@Data/files/Interfaces';

const FileUploadHeaderSelector = (props) => {
    const { placeholder, onSelect, options, selectedHeader, id } = props;

    const selectRef = useRef();

    const selectOptions = options.map((opt: IFileUploadHeader, index) => {
        return (
            <SelectOption
                id={`${id}-${opt.value}`}
                text={opt.value}
                parentRef={selectRef}
                onClick={() => onSelect(opt)}
                key={`${placeholder}${opt.index}`}
            />
        );
    });

    return (
        <Select
            id={id}
            ref={selectRef}
            value={selectedHeader ? selectedHeader.value : ''}
            label={placeholder}
        >
            {selectOptions}
        </Select>
    );
};

FileUploadHeaderSelector.propTypes = {
    placeholder: PropTypes.string,
    onSelect: PropTypes.func,
    onClear: PropTypes.func,
    options: PropTypes.array,
    selectedHeader: PropTypes.object,
    id: PropTypes.string,
};
export default FileUploadHeaderSelector;
